// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__WIUjh","choiceBoxes":"toolbarselects_choiceBoxes__3hpWe","simpleField":"toolbarselects_simpleField__8wR9O"};